import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { getDaysUntilBirthday, formatBirthdayDate } from '../lib';

interface BirthdayCardProps {
  birthDate: string; // формат YYYY-MM-DD
}

/**
 * Карточка с информацией о дне рождения
 * Показывается в профиле пользователя
 */
export const BirthdayCard = memo(function BirthdayCard({ birthDate }: BirthdayCardProps): JSX.Element {
  const { t } = useTranslation();
  const daysUntil = getDaysUntilBirthday(birthDate);
  const formattedDate = formatBirthdayDate(birthDate);

  return (
    <div className="p-4 rounded-[var(--radius)] bg-[var(--yellow-birthday)]">
      <div className="flex items-center justify-between">
        {/* Левая часть: иконка + текст */}
        <div className="flex items-center gap-3">
          <div className="text-3xl">
            🎂
          </div>
          <div>
            <p className="text-base font-semibold text-[var(--yellow-birthday-text)]">
              {t('profile:user.birthday.title')}
            </p>
            <p className="text-sm font-normal text-[var(--yellow-birthday-text)]">
              {formattedDate}
            </p>
          </div>
        </div>

        {/* Правая часть: "через X дней" или "Сегодня" */}
        <div className="bg-[var(--white)] px-3 py-2 rounded-[12px]">
          {daysUntil === 0 ? (
            <p className="text-sm font-semibold text-[var(--yellow-birthday-text)] whitespace-nowrap">
              {t('profile:user.birthday.today')}
            </p>
          ) : (
            <p className="text-sm font-semibold text-[var(--yellow-birthday-text)] whitespace-nowrap">
              {t('profile:user.birthday.daysLeft', { count: daysUntil })}
            </p>
          )}
        </div>
      </div>
    </div>
  );
});